import { Chip, Stack, Tooltip } from '@mui/material';

import SlashIcon from '@/components/Icons/SlashIcon';
import StatusBadge from '@/components/StatusBadge';

import { getPrimaryStatus } from '../../utils';
import { ProductionStatusProps } from './types';

function ProductionStatus({ primary }: ProductionStatusProps) {
  return (
    <Stack direction="row" gap={1} justifyContent="flex-start" alignItems="center">
      {primary && primary.isPrimary ? (
        <StatusBadge status={getPrimaryStatus(primary)} />
      ) : (
        <Tooltip
          title={`No production deployment for this ${
            // eslint-disable-next-line no-underscore-dangle
            primary.__typename === 'ModelVersionType' ? 'model' : 'chain'
          }.`}
        >
          <Chip
            icon={<SlashIcon color="secondary" />}
            label="No deployment"
            size="small"
            color="default"
          />
        </Tooltip>
      )}
    </Stack>
  );
}

export default ProductionStatus;
